import { Injectable, EventEmitter } from '@angular/core';
import { UUID } from 'angular2-uuid';

import { ENVIRONMENT } from '../../environments/environment';
import CONFIGURATION from '../../configurations/configuration';

@Injectable()
export class MyInfoService {
  hideMyInfoAndManualSelectionEventEmitter: EventEmitter<any>;
  constructor(
  ) {
    this.hideMyInfoAndManualSelectionEventEmitter = new EventEmitter(true);
  }

  getAuthoriseUrl(memberType: string, attributes: string): string {
    let clientId = '';
    if (memberType === CONFIGURATION.member_type_code.borrower) {
      clientId = ENVIRONMENT.myinfo.borrower.clientId;
    } else if (memberType === CONFIGURATION.member_type_code.investor) {
      clientId = ENVIRONMENT.myinfo.investor.clientId;
    }
    const redirect_uri = ENVIRONMENT.myinfo.callbackUrl;
    const uuid = UUID.UUID();
    const authoriseUrl = ENVIRONMENT.service.myinfo + '/authorise'
      + '?client_id=' + clientId
      + '&attributes=' + attributes
      + '&purpose=' + 'borrowerSignUp'
      + '&state=' + uuid
      + '&redirect_uri=' + redirect_uri;

    return authoriseUrl;
  }

}
